/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Partner_Org_DescInputs */



/**
* | output |
* | --- |
* | "Your organization is managed by a partner. Plan changes are handled by your partner, so contact them to upgrade." |
*
* @param {Pricing_Partner_Org_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_partner_org_desc = /** @type {((inputs?: Pricing_Partner_Org_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Partner_Org_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Organisation wird von einem Partner verwaltet. Tarifänderungen erfolgen über Ihren Partner, bitte kontaktieren Sie ihn für ein Upgrade.")
	return /** @type {LocalizedString} */ ("Your organization is managed by a partner. Plan changes are handled by your partner, so contact them to upgrade.")
});